"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceChart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const styled_1 = require("@framework/styled");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_user_1 = require("@dzambalaorg/provider-user");
const search_form_1 = require("./search-form");
const chart_creator_1 = require("./chart-creator");
const schemas_1 = require("./schemas");
const MarketplaceChart = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const chartRef = (0, react_1.useRef)(null);
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return (0, schemas_1.marketplaceChartSearchParams)(profile)[service];
    }, [profile]);
    const { isLoading, allRows } = (0, react_hooks_1.useFetchQuery)("/marketplace/report/chart", void 0, void 0, initialSearchValues);
    const clearChart = (0, react_1.useCallback)(() => {
        while (chartRef.current?.lastChild) {
            chartRef.current.removeChild(chartRef.current.lastChild);
        }
    }, [chartRef.current]);
    (0, react_1.useEffect)(() => {
        if (!chartRef.current) {
            return;
        }
        if (!allRows.length) {
            clearChart();
        }
        else {
            (0, chart_creator_1.chartCreator)(chartRef, allRows, clearChart);
        }
    }, [chartRef.current, allRows]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "marketplace", "marketplace.chart"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.marketplace.chart.title" }), (0, jsx_runtime_1.jsx)(search_form_1.MarketplaceChartSearchForm, { initialSearchValues: initialSearchValues, service: service }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledEmptyWrapper, { count: allRows.length, isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(material_1.Box, { mt: 4, width: "100%", ref: chartRef }) }) })] }));
};
exports.MarketplaceChart = MarketplaceChart;
//# sourceMappingURL=index.js.map